import { render, staticRenderFns } from "./DeactivateForm.vue?vue&type=template&id=4f4dbf04&scoped=true&"
import script from "./DeactivateForm.vue?vue&type=script&lang=js&"
export * from "./DeactivateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4dbf04",
  null
  
)

export default component.exports